import * as React from 'react';

function FootNotesIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.66666 4.00007L11.8682 4C12.1246 4 12.3711 4.09844 12.557 4.27499L14.6887 6.30013C14.8875 6.48892 15 6.75102 15 7.02513V15.1821C15 15.503 14.7844 15.742 14.5274 15.7899C11.5041 16.3531 8.49597 16.3531 5.4726 15.7899C5.21562 15.742 5.00003 15.503 5.00003 15.1821L5 4.66674C5 4.29855 5.29847 4.00007 5.66666 4.00007ZM11.8682 2L5.66664 2.00007C4.19389 2.00009 3 3.19399 3 4.66674L3.00003 15.1821C3.00003 16.4062 3.84448 17.521 5.10633 17.756C8.37179 18.3643 11.6282 18.3643 14.8937 17.756C16.1555 17.521 17 16.4062 17 15.1821V7.02513C17 6.20279 16.6624 5.41649 16.0662 4.85011L13.9344 2.82497C13.3769 2.29531 12.6372 1.99999 11.8682 2ZM8.16699 10.6665C7.06242 10.6665 6.16699 11.5619 6.16699 12.6665C6.16699 13.7711 7.06242 14.6665 8.16699 14.6665H11.667C12.7716 14.6665 13.667 13.7711 13.667 12.6665C13.667 11.5619 12.7716 10.6665 11.667 10.6665H8.16699Z"
        className="fill-icn-txt-sec"
      />
    </svg>
  );
}

export default FootNotesIcon;
